"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.SIZE = exports.PRIORITY = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var Button_st_css_1 = require("./Button.st.css");
var button_next_1 = require("wix-ui-core/button-next");
var TPAComponentsConfig_1 = require("../TPAComponentsConfig");
var deprecationLog_1 = require("../../common/deprecationLog");
var PRIORITY;
(function (PRIORITY) {
    PRIORITY["basic"] = "basic";
    PRIORITY["primary"] = "primary";
    PRIORITY["secondary"] = "secondary";
    PRIORITY["basicSecondary"] = "basicSecondary";
})(PRIORITY = exports.PRIORITY || (exports.PRIORITY = {}));
var SIZE;
(function (SIZE) {
    SIZE["tiny"] = "tiny";
    SIZE["small"] = "small";
    SIZE["medium"] = "medium";
    SIZE["large"] = "large";
})(SIZE = exports.SIZE || (exports.SIZE = {}));
var ButtonComponent = /** @class */ (function (_super) {
    __extends(ButtonComponent, _super);
    function ButtonComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._wrapAffix = function (icon, type) {
            return (React.createElement("span", { className: classnames_1.default(Button_st_css_1.classes[type + "-icon"], Button_st_css_1.classes.affixIcon) }, icon));
        };
        _this._getAffixes = function () {
            var _a = _this.props, prefixIcon = _a.prefixIcon, suffixIcon = _a.suffixIcon;
            var hasIcons = prefixIcon || suffixIcon;
            return hasIcons
                ? {
                    prefixIcon: prefixIcon
                        ? _this._wrapAffix(prefixIcon, 'prefix')
                        : undefined,
                    suffixIcon: suffixIcon
                        ? _this._wrapAffix(suffixIcon, 'suffix')
                        : undefined,
                }
                : null;
        };
        return _this;
    }
    ButtonComponent.prototype.componentDidMount = function () {
        if (!this.props.upgrade) {
            deprecationLog_1.deprecationLog('Button', 'The current `Button` component API will be deprecated in the next major version. Please use the `upgrade` prop in order to use the new API.');
        }
    };
    ButtonComponent.prototype._getDataAttributes = function (mobile) {
        var fullWidth = this.props.fullWidth;
        return {
            'data-fullwidth': fullWidth,
            'data-mobile': mobile,
        };
    };
    ButtonComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, priority = _a.priority, size = _a.size, fullWidth = _a.fullWidth, innerRef = _a.innerRef, upgrade = _a.upgrade, children = _a.children, className = _a.className, rest = __rest(_a, ["priority", "size", "fullWidth", "innerRef", "upgrade", "children", "className"]);
        var affixes = this._getAffixes();
        return (React.createElement(TPAComponentsConfig_1.TPAComponentsConsumer, null, function (_a) {
            var _b;
            var mobile = _a.mobile;
            return (React.createElement(button_next_1.ButtonNext, __assign({}, _this._getDataAttributes(mobile), { ref: innerRef, children: children, "data-hook": _this.props['data-hook'], className: Button_st_css_1.st(Button_st_css_1.classes.root, {
                    priority: priority,
                    size: size,
                    fullWidth: fullWidth,
                    mobile: mobile,
                    upgrade: upgrade,
                }, classnames_1.default(className, (_b = {}, _b[Button_st_css_1.classes.hasIcon] = !!affixes, _b))) }, rest, affixes)));
        }));
    };
    ButtonComponent.contextType = TPAComponentsConfig_1.TPAComponentsContext;
    ButtonComponent.displayName = 'Button';
    ButtonComponent.defaultProps = {
        fullWidth: false,
        upgrade: false,
    };
    return ButtonComponent;
}(React.Component));
exports.Button = React.forwardRef(function (props, ref) { return (React.createElement(ButtonComponent, __assign({}, props, { innerRef: ref }))); });
//# sourceMappingURL=Button.js.map